import ErrorLayout from "@app/layouts/ErrorLayout/ErrorLayout";
import { VideoLandingData } from "@app/routes/VideoLanding/utils";
import { fetchVideoLandingData } from "@app/routes/VideoLanding/VideoLandingPage.server";
import AdSettings from "@app/utils/AdSettings";
import MetaData from "@components/Modules/MetaData";
import { GlobalBaseData } from "@sphtech/dmg-design-system";
import {
  TRouteWithoutRedirect,
  TRouteWithRedirect,
} from "@sphtech/web2-core/ssr";
import { dataLoader } from "@src/app/utils/dataLoader";
import { useLoaderData, useLocation } from "react-router";

import PubBaseLayout from "../BaseLayout";
import VideoLandingLayout from "../VideoLandingLayout/VideoLanding";

export const meta = () => {
  return MetaData({
    title: "Videos",
    type: "WebPage",
    path: "/videos",
  });
};

export default function VideoLandingPage() {
  const data: TRouteWithoutRedirect<VideoLandingData, string> = useLoaderData();
  const location = useLocation();

  if (data.statusCode !== 200) {
    return <ErrorLayout response={data} />;
  }

  return (
    <PubBaseLayout>
      <AdSettings
        pageType="videos"
        sectionName="videos"
        adUnits="lb1,lb2,catfish,prestitial"
        pageTitle="Videos"
        currentLocation={location}
      />
      <VideoLandingLayout
        data={{
          name: data.payload.videoLandingTitle,
          subHeading: "",
          anchorListTitle: data.payload.anchorListTitle,
          anchorList: data.payload.anchorList,
          playlists: data.payload.playlists,
        }}
      />
    </PubBaseLayout>
  );
}

export async function loader(): Promise<
  TRouteWithRedirect<VideoLandingData | GlobalBaseData, GlobalBaseData | string>
> {
  const data = await fetchVideoLandingData();

  return await dataLoader({
    type: data.type,
    dataSource: data,
  });
}
